<template lang="pug">
  #app
    app-navigation
    .loader(v-if="loading")
      Spinner
    router-view
    app-footer(v-if="!loading")
</template>

<script>
import debug from 'debug'
import { mapActions, mapState } from 'vuex'
import AppNavigation from '@/components/AppNavigation'
import AppFooter from '@/components/AppFooter'
import Spinner from '@/components/Spinner'

const log = debug('app')

export default {
  name: 'app',
  data () {
    return {
    }
  },
  beforeCreate () {
    this.$store.dispatch('getGlobals')
  },
  created () {
    this.init(this.$parent.site)
  },
  mounted () {
    log('App Mounted', this.$parent.site)
    // console.log('app mounted')
    window.addEventListener('resize', this.setIsMobile)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setIsMobile)
  },
  computed: {
    ...mapState(['site', 'loading']),
  },
  methods: {
    ...mapActions(['init', 'setLoading', 'setIsMobile']),
  },
  components: {
    AppNavigation,
    AppFooter,
    Spinner,
  },
}
</script>

<style lang="scss">
@import './styles/main';

.loader {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 60px;
  height: 60px;
  transform: translate(-50%, -50%);
}

</style>
